module.exports = __webpack_public_path__ + "assets/img/shengyin.6d2e74e0.png";